import type { RouteObject } from 'react-router-dom';

/**
 * Feature route registry. Each entry is a child of the locale-scoped layout
 * (`/{locale}/...`). Features own their routes; pages stay thin shells that
 * compose feature widgets.
 *
 * To add a new feature route from a feature module:
 *
 *   // features/wishlist/routes.tsx
 *   import { lazy } from 'react';
 *   const WishlistPage = lazy(() => import('./ui/WishlistPage'));
 *   export const wishlistRoutes: RouteObject[] = [
 *     { path: 'wishlist', element: <WishlistPage /> },
 *   ];
 *
 *   // here:
 *   import { wishlistRoutes } from '@/features/wishlist/routes';
 *   ...wishlistRoutes,
 *
 * Keep this file the SINGLE place where feature routes are wired into the app.
 * The router itself stays mechanical.
 */
export const featureRoutes: RouteObject[] = [
  // populated by feature modules as they land
];
